<template>
  <header class="header">
    <div class="site-header container">
      <router-link to="/" class="site-header__inner">
        <img src="@images/logotype.svg" class="site-header__logo" alt="ТУСУР">
        <span class="site-header__title desktop-only">
          Кабинет абитуриента ТУСУР
        </span>
      </router-link>
      <div class="site-header__actions">
        <button
          class="btn btn--squared btn--outline-primary mobile-only"
          :class="{ 'icon--active': isOpen }"
          @click="toggle"
        >
          <img v-svg-inline src="@images/menu.svg" class="btn__icon" alt="">
        </button>
      </div>
    </div>
  </header>
</template>

<script setup>
import { useNavMenu } from '../composables/useNavMenu'
const { isOpen, toggle } = useNavMenu()
</script>
